import { render, staticRenderFns } from "./Objeto.vue?vue&type=template&id=a9a03a5a&scoped=true&"
import script from "./Objeto.vue?vue&type=script&lang=js&"
export * from "./Objeto.vue?vue&type=script&lang=js&"
import style0 from "./Objeto.vue?vue&type=style&index=0&id=a9a03a5a&lang=scss&scoped=true&"
import style1 from "./Objeto.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a03a5a",
  null
  
)

export default component.exports